const QUERY_KEYS = {
  ANALYTICS: 'ANALYTICS',
  APP_INFO: 'APP_INFO',
  BILLING_ORGANIZATIONS: 'BILLING_ORGANIZATIONS',
  CONNECTIONS: 'CONNECTIONS',
  FLOWS: 'FLOWS',
  FLOWS_LIST: 'FLOWS_LIST',
  FLOW_DETAIL: 'FLOW_DETAIL',
  FLOW_CALL: 'FLOW_CALL',
  FLOW_CALLS: 'FLOW_CALLS',
  FLOW_EXECUTION: 'FLOW_EXECUTION',
  FLOW_EXECUTION_SEARCH: 'FLOW_EXECUTION_SEARCH',
  FLOW_RECENT_RUNS: 'FLOW_RECENT_RUNS',
  FLOW_SCHEMA: 'FLOW_SCHEMA',
  FLOW_SUBSTORE: 'FLOW_SUBSTORE',
  NODE_ACTION_INPUT_FIELDS: 'NODE_ACTION_INPUT_FIELDS',
  NODE_ACTION_OUTPUT_FIELDS: 'NODE_ACTION_OUTPUT_FIELDS',
  NODE_CALL_INPUT_DETAIL: 'NODE_CALL_INPUT_DETAIL',
  NODE_CALL_OUTPUT_DETAIL: 'NODE_CALL_OUTPUT_DETAIL',
  NODE_CALL_RAW_DATA_DETAIL: 'NODE_CALL_RAW_DATA_DETAIL',
  NODE_CONNECTION_INPUT_FIELDS: 'NODE_CONNECTION_INPUT_FIELDS',
  NODE_CONNECTION_OPTIONS: 'NODE_CONNECTION_OPTIONS',
  NODE_RESOURCES: 'NODE_RESOURCES',
  ORGANIZATIONS: 'ORGANIZATIONS',
  ORGANIZATION_CONNECTIONS: 'ORGANIZATION_CONNECTIONS',
  ORGANIZATION_USERS: 'ORGANIZATION_USERS',
  // ORGANIZATION_WEBHOOKS: 'ORGANIZATION_WEBHOOKS',
  PROJECTS: 'PROJECTS',
  PROJECTS_LIST: 'PROJECTS_LIST',
  PROJECT_STORE: 'PROJECT_STORE',
  PROJECT_DETAIL: 'PROJECT_DETAIL',
  USER_DATA: 'USER_DATA',
  USER_ORGANIZATIONS: 'USER_ORGANIZATIONS',
  AI_HANDOFF_SETUP: 'AI_HANDOFF_SETUP',
  AI_ANTHROPIC_KEY: 'AI_ANTHROPIC_KEY',
  // The last answer each AI surface stored, so reopening one shows what was
  // already paid for instead of running the model again.
  AI_FLOW_EXPLANATION: 'AI_FLOW_EXPLANATION',
  AI_DIAGNOSIS: 'AI_DIAGNOSIS',
  // WEBHOOK_DETAIL: 'WEBHOOK_DETAIL',
};

export default QUERY_KEYS;
